import { PageHero } from "../components/Sections";
import { PageSeo } from "../components/PageContent";
import { SmartLink } from "../components/SiteChrome";
import { legalPages } from "../content/pagesContent";

export default function LegalPage({ type }) {
  const page = legalPages[type];
  const hero = { headline: page.headline, subheading: page.subheading, image: page.image, imagePosition: "center", ctas: [] };
  return (
    <>
      <PageSeo page={page} />
      <PageHero content={hero} />
      <article className="legal-document">
        <header className="legal-document-intro">
          <p className="legal-updated">{page.updated}</p>
          {page.introduction.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        </header>
        {page.sections.map((section) => (
          <section className="legal-section" key={section.heading}>
            <h2>{section.heading}</h2>
            <div className="legal-section-copy">
              {section.paragraphs?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
              {section.bullets && <ul>{section.bullets.map((item) => <li key={item}>{item}</li>)}</ul>}
              {section.closing && <p>{section.closing}</p>}
              {section.link && <SmartLink className="text-link" target={section.link.target}>{section.link.label}</SmartLink>}
            </div>
          </section>
        ))}
        <footer className="legal-contact">
          <h2>Contact</h2>
          <SmartLink className="button button-primary" target={page.contact.target}>{page.contact.label}</SmartLink>
        </footer>
      </article>
    </>
  );
}
